/** TO DO: fix the rule */
/* eslint-disable @ngrx/on-function-explicit-return-type */
import { Action, createReducer, on } from '@ngrx/store';
import { AppFlow, Delayed, PageControl } from '../lemans-app.model';
import { getUserPreferencesFailed, getUserPreferencesSuccess } from '../user-data';
import {
  acceptEULASuccess,
  baseURLSuccess,
  getApplications,
  getEnabledApplications,
  initAppRoute,
  setAppIntialRoute,
  setErrorContext,
  setEulaConfigSuccess,
  setExtendSession,
  setHelpMenuToOpen,
  setLogoutSession,
  setProductCatalogSuccess,
  setSessionTimedOut,
  setUserActive,
  setVersions,
  userLoginComplete,
} from './control-page.actions';

export const initialState: PageControl = {
  isBaseURLSet: false,
  isEulaAccepted: false,
  isUserFound: new Delayed<boolean>(),
  isUserActive: false,
  sessionTimedOut: false,
  extendSession: false,
  logoutSession: false,
  // REVISIT: Possibly dangerous?, why doesn't directly initializing this work?
  applications: [],
  appsMap: {},
  enabledApplications: [],
  helpMenuToOpen: { id: '', displayName: '' },
  routeState: {
    flow: AppFlow.Dashboard,
  },
  catalogInfo: new Delayed(),
};

const pageActions = createReducer(
  initialState,

  on(initAppRoute, (state: PageControl, { payload }) => ({
    ...state,
    isEulaAccepted: !payload.eulaAcceptanceRequired,
  })),
  on(acceptEULASuccess, (state: PageControl) => ({
    ...state,
    isEulaAccepted: true,
  })),
  on(getUserPreferencesFailed, (state: PageControl, { value }) => ({
    ...state,
    isUserFound: value.status === 404 ? new Delayed(false) : state.isUserFound,
  })),
  on(getUserPreferencesSuccess, (state: PageControl) => ({
    ...state,
    isUserFound: new Delayed(true),
  })),
  on(getApplications, (state: PageControl, { payload }) => {
    const appsMap = {};
    payload.forEach((app) => (appsMap[app.appId] = app));
    return {
      ...state,
      appsMap: appsMap,
      applications: payload,
    };
  }),
  on(getEnabledApplications, (state: PageControl, { payload }) => ({
    ...state,
    enabledApplications: payload,
  })),
  on(baseURLSuccess, (state: PageControl, { value }) => ({ ...state, isBaseURLSet: value })),
  on(setEulaConfigSuccess, (state: PageControl, { payload }) => ({ ...state, eulaConfig: payload })),
  on(setErrorContext, (state: PageControl, { payload }) => ({ ...state, apiError: payload })),
  on(setProductCatalogSuccess, (state: PageControl, { payload }) => ({
    ...state,
    catalogInfo: new Delayed(payload),
  })),
  on(setVersions, (state: PageControl, { value }) => ({ ...state, versions: value })),
  on(setUserActive, (state: PageControl, { value }) => ({ ...state, isUserActive: value })),
  on(setSessionTimedOut, (state: PageControl, { value }) => ({ ...state, sessionTimedOut: value })),
  on(setExtendSession, (state: PageControl, { value }) => ({ ...state, extendSession: value })),
  on(setLogoutSession, (state: PageControl, { value }) => ({ ...state, logoutSession: value })),
  on(setAppIntialRoute, (state: PageControl, { payload }) => ({ ...state, routeState: payload })),
  on(setHelpMenuToOpen, (state: PageControl, { value }) => ({ ...state, helpMenuToOpen: value })),
  on(userLoginComplete, (state: PageControl, { payload }) => ({ ...state, loggedInUserProfile: payload })),
);

export function controlPageReducer(state: PageControl, action: Action): PageControl {
  return pageActions(state, action);
}
